export const MODE_READONLY_UI_FLIGHT_MARKER_MOVE_ENABLED =
  "MODE_READONLY_UI_FLIGHT_MARKER_MOVE_ENABLED";
export const enableReadonlyFlightMarkerMove = (
  fightMarkerId: string,
): IAction<string> => ({
  type: MODE_READONLY_UI_FLIGHT_MARKER_MOVE_ENABLED,
  payload: fightMarkerId,
});

const MODE_READONLY_UI_FLIGHT_MARKER_MOVE_DISABLED =
  "MODE_READONLY_UI_FLIGHT_MARKER_MOVE_DISABLED";
export const disableReadonlyFlightMarkerMove = (): IAction<void> => ({
  type: MODE_READONLY_UI_FLIGHT_MARKER_MOVE_DISABLED,
  payload: null,
});

const MODE_READONLY_UI_FLIGHT_MARKER_LABELS_TOGGLED =
  "MODE_READONLY_UI_FLIGHT_MARKER_LABELS_TOGGLED";
export const toggleReadonlyFlightMarkerLabels = (): IAction<void> => ({
  type: MODE_READONLY_UI_FLIGHT_MARKER_LABELS_TOGGLED,
  payload: null,
});

export interface IModeReadonlyUi {
  flightMarkerIdToMove?: string;
  showFlightMarkerLabelsIsOn: boolean;
}

const defaultState: IModeReadonlyUi = {
  flightMarkerIdToMove: null,
  showFlightMarkerLabelsIsOn: false,
};

export default function reducer(
  state: IModeReadonlyUi = defaultState,
  action: IAction<any>,
): IModeReadonlyUi {
  switch (action.type) {
    case MODE_READONLY_UI_FLIGHT_MARKER_MOVE_ENABLED:
      return {
        ...state,
        flightMarkerIdToMove: action.payload,
      };
    case MODE_READONLY_UI_FLIGHT_MARKER_MOVE_DISABLED:
      return {
        ...state,
        flightMarkerIdToMove: null,
      };
    case MODE_READONLY_UI_FLIGHT_MARKER_LABELS_TOGGLED:
      return {
        ...state,
        showFlightMarkerLabelsIsOn: !state.showFlightMarkerLabelsIsOn,
      };
    default:
      return state;
  }
}
